module.exports = __webpack_public_path__ + "static/media/ApP-Logo-weiss.1ede2441.svg";